export default {
    coach: null,
    available_dates: [],
    available_times: [],
    available_timespans: [],
    available_timespan_count: 0,
};



// WEBPACK FOOTER //
// ./src/store/coach/state.js